import App from "../../components/ShareLinksPages.vue";
import createSharePage from "../../utils/createSharePage.js";

createSharePage(App, "share-links-pages");